module.exports = __webpack_public_path__ + "img/02.5663b692.jpg";